import React, { memo, useCallback, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import menu from './Menu';
import { NotFound } from '../pages/notFound';

function prepareRoutes() {
    const getRoutes = (lista) => {
        let routes = [];
        for (let i = 0; i < lista.length; i++) {
            const el = lista[i];
            if (el.items) {
                routes = [...routes, ...getRoutes(el.items)];
            } else {
                routes.push(el);
            }
        }
        return routes;
    };

    let childs = getRoutes(menu());

    childs = childs.filter((el) => el?.visibleOnRouter);

    return childs;
}

export const ApplicationContext = React.createContext(null);

const Router = () => {
    const routeList = prepareRoutes();
    const [state, setState] = useState({});
    const refreshContext = useCallback((newData) => setState(newData), []);

    return (
        <ApplicationContext.Provider
            value={{
                ...state,
                refreshContext,
            }}
        >
            <Switch>
                {routeList.map((obj, index) => (
                    <Route key={index} path={obj.to} exact component={obj.component} />
                ))}
                <Route path="*" component={NotFound} />
            </Switch>
        </ApplicationContext.Provider>
    );
};
export default memo(Router);
